@if (visible()) {
  <div class="relative z-1000 w-max pl-2">
    <div class="bg-white border border-gray-100 shadow px-4 py-2 absolute -top-24 w-max -right-64">
      <div class="text-yellow-500 flex flex-row align-middle gap-2">
        <vti-icons class="pt-1" [icon]="'warning'" color="yellow" colorTint="400" size="5"></vti-icons>
        <span class="text-vti-900" [innerText]="title()"></span>
      </div>
      <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse gap-x-2">
        <button
          type="button"
          class="text-sm inline-flex items-center px-2 text-white bg-vti-900 hover:bg-vti-900 focus:ring-2 focus:ring-offset-2 focus:ring-vti-900 focus:outline-none border border-vti-900 rounded"
          (click)="onOkClick()"
          i18n
        >
          Yes
        </button>
        <button type="button" class="text-sm inline-flex items-center px-2 text-vti bg-transparent" (click)="onCancelClick()" i18n>No</button>
      </div>
    </div>
  </div>
}
